// ASSETS
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";

// STYLES
import {
  NewsCardContainer,
  ImgCard,
  TitleText,
  Subtitle,
  WrapperButton,
  PartnerName,
} from "./NewsCardStyled";

// LIBRARIES

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC

import { IProps } from "./NewsCardModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { COLORS } from "constants/variables";
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";

// REDUX
import { useSelector } from "react-redux";
import { selectLanguage } from "slices/LanguageSlice/languageSlice";

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";

const NewsCard = (props: IProps) => {
  // PROPERTIES
  const {
    id,
    img,
    title = "",
    timeToRead = "",
    partner = "",
    timeline = "",
    route = "",
  } = props;

  // LIBRARY CONSTANTS
  const { t } = useTranslation();
  const navigate = useNavigate();
  const selectedLanguage = useSelector(selectLanguage);

  // STATE CONSTANTS

  // API REQUESTS

  // LIFE CYCLE

  // EVENT HANDLERS

  const handleClick = (id) => {
    navigate(`${route}${id}`);
  };
  const formatDateToMonthDD = (date) => {
    const d = new Date(date);
    const day = d.getDate();
    const year = d.getFullYear();
    const locale = selectedLanguage === "ro" ? "ro-RO" : "en-US";

    let weekday = d.toLocaleDateString(locale, { weekday: "long" });
    let month = d.toLocaleDateString(locale, { month: "long" });

    weekday = weekday.charAt(0).toUpperCase() + weekday.slice(1);
    month = month.charAt(0).toUpperCase() + month.slice(1);

    return `${weekday}, ${day} ${month} ${year}`;
  };

  return (
    <NewsCardContainer onClick={() => handleClick(id)}>
      <ImgCard src={img ? img : CoverPlaceholder} />
      <TitleText>
        <CustomText type={TextType.H3} text={title} />
      </TitleText>

      <Subtitle>
        <PartnerName>
          <CustomText
            type={TextType.H6semiBold}
            text={partner}
            color={COLORS.RaisinBlack}
          />
        </PartnerName>
        {/* <CustomText
          type={TextType.H5}
          text={timeToRead}
          color={COLORS.Crimson}
        /> */}

        <CustomText
          type={TextType.H6}
          text={formatDateToMonthDD(timeline)}
          color={COLORS.MetalicSilver}
        />
      </Subtitle>
      <WrapperButton>
        <ButtonAtom
          type={ButtonType.RedButton}
          text={t("view.newsAndMedia.officialAnnouncements.openButton")}
          hasArrow={true}
          onClick={() => handleClick(id)}
        />
      </WrapperButton>
    </NewsCardContainer>
  );
};

export default NewsCard;
